// packages/api-client/queries/descriptors/index.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createDescriptorsQueries = (requests, queryClient) => ({
    useListDescriptors: (params, options = {}) => useQuery({
        queryKey: ["descriptors", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listDescriptors(params);
        },
        ...options,
    }),
    useListMostUsedDescriptors: (params, options = {}) => useQuery({
        queryKey: ["descriptors", "most-used", params],
        queryFn: async ({ queryKey }) => {
            const [, , params] = queryKey;
            return requests.listMostUsedDescriptors(params);
        },
        ...options,
    }),
    useFindDescriptor: (params, options = {}) => useQuery({
        queryKey: ["descriptors", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findDescriptor(params);
        },
        ...options,
    }),
    useCreateDescriptor: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.createDescriptor(attrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ["descriptors"] });
            options.onSuccess?.(...args);
        },
    }),
    useApproveDescriptor: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.approveDescriptor(attrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ["descriptors"] });
            options.onSuccess?.(...args);
        },
    }),
    useRejectDescriptor: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.rejectDescriptor(attrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ["descriptors"] });
            options.onSuccess?.(...args);
        },
    }),
    useUpdateDescriptor: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.updateDescriptor(attrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ["descriptors"] });
            options.onSuccess?.(...args);
        },
    }),
    useAssignDescriptorToGroups: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.assignDescriptorToGroups(attrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ["descriptors"] });
            options.onSuccess?.(...args);
        },
    }),
});
//# sourceMappingURL=index.js.map